import { each, find } from "lodash";
import * as React from "react";
import * as request from "superagent";
import discoveryAPI from "../../api/discovery-api";
// import * as userActions from "../../stores/user/actions";

import { Box, Button, LinearProgress, ListItem } from "@mui/material";
import { saveButtonProps } from "../../../lib/button-styles";
import {
  invalidPasswordMessage,
  isValidPassword
} from "../../../lib/validation/index";
import { IUser } from "../../stores/jotai/base";
import * as uuid from "../../util/uuid";

interface IErrorMap {
  errorMap: {
    [name: string]: string;
  };
}
interface State {
  photoData?: File;
  photoID?: string;

  changed?: boolean;
  saving?: boolean;
  savingPhoto?: boolean;

  oryMode?: boolean;

  existingSlackChannels: [];
  loadingSlackChannels: boolean;

  cachedSlackURL: string;

  loadingNotificationSettings: boolean;
  notificationToggle: boolean;

  errors?: {
    [key: string]: {
      [key: string]: string;
    };
  };
}
interface Props {
  cohortID: string;
  orgID: string;
  user?: IUser;
  handleDialogClose: any;
}
interface IRefs {
  [key: string]: React.Component<any, any>;
  name: Input;
  email: Input;
  password: Input;
  confirmPassword: Input;
}
export default class ProfileEditDialog extends React.Component<Props, State> {
  refs: IRefs;
  state: State = {
    photoID: undefined,
    existingSlackChannels: [],
    loadingSlackChannels: true,
    cachedSlackURL: "",
    loadingNotificationSettings: true,
    notificationToggle: true,
    oryMode: false
  };

  // Establish our uppy context
  uppy: any;
  componentDidMount() {
    //@ts-ignore
    if ((typeof window !== "undefined" ? window : {}).inOryMode !== true) {
      this.setState({
        oryMode: true
      });
    }
    this.getNotificationSettings();

    try {
      request
        .get(
          process.env.NEXT_PUBLIC_SLACK_INTEGERATION_URI +
            "channel?channelOfUserID=" +
            this.state.user.id
        )
        .end((err, res) => {
          try {
            this.setState({
              loadingSlackChannels: false,
              existingSlackChannels: JSON.parse(res?.text)
            });
          } catch (e) {
            this.setState({
              loadingSlackChannels: true
            });
          }
        });
    } catch (e) {}
  }

  getNotificationSettings = () => {
    this.setState({
      loadingNotificationSettings: true
    });

    request
      .get(
        "https://j213uzs44m.execute-api.us-west-2.amazonaws.com/?action=get&userID=" +
          this.props.user?.id
      )
      .end((err, res) => {
        let payload = {
          muted: false
        };

        try {
          const blob = JSON.parse(res?.text)?.muted;
          payload.muted = blob === "true" || blob === true;
        } catch (e) {}

        this.setState({
          loadingNotificationSettings: false,
          notificationToggle: payload?.muted
        });
      });
  };

  openOrySettings = () => {
    // send them off to the ory settings page
    (typeof window !== "undefined" ? window : {}).open(
      "https://innovationwithin.services/settings",
      "_blank"
    );
  };

  saveNotificationSettings = (callback) => {
    this.setState({
      loadingNotificationSettings: true
    });

    request
      .get(
        "https://j213uzs44m.execute-api.us-west-2.amazonaws.com/?action=put&data=" +
          this.state.notificationToggle.toString() +
          "&userID=" +
          this.state.user.id
      )
      .end((err, res) => {
        callback();
      });
  };

  // TODO: remove error handling
  // TODO: determine if this should be a part of Container (base class) or if each container should implement it itself
  /** method is used as subscription handler to Store.errors */
  errorHandler = (error: any) => {
    if (!error.type) {
      error = {
        type: "validate",
        payload: error
      };
    }

    this.setState({
      errors: {
        [error.type]: error.payload
      }
    });
  };

  /** parses error object down to specifically the fields that the API returned (essentially this ignores the top-level ActionSignature.type) */
  getErrors(errors: StoreErrors, errorTypes: string[]): IErrorMap {
    let errorObject: IErrorMap = {
      errorMap: {}
    };

    errorTypes.map((field) => {
      errorObject.errorMap[field] = null;
    });

    if (errors) {
      each(errors, (apiErrors, actionType) => {
        each(apiErrors, (error, errorType) => {
          errorObject.errorMap[errorType] = error;
        });
      });
    }

    return errorObject;
  }

  doneUploading = () => {
    this.setState({
      savingPhoto: false,
      changed: true
    });
  };

  handleFile = (files: FileList) => {
    const newImage = files[0];

    this.setState({
      savingPhoto: true,
      photoData: newImage
    });

    // Trigger the uppy "addFile" api manually
    this.uppy.addFile({
      name: uuid.generate(),
      type: newImage?.type,
      data: newImage,
      source: "Local",
      isRemote: false
    });
  };

  updateProfile = (event) => {
    let { state, refs } = this,
      { name, email, password, confirmPassword } = refs;

    const { photoID } = this.state;

    if (password.getValue()) {
      if (password.getValue() !== confirmPassword.getValue()) {
        return this.setState({
          errors: {
            "user.updateDetails": {
              password: "passwords do not match"
            }
          }
        });
      } else if (!isValidPassword(password.getValue())) {
        return this.setState({
          errors: {
            updateDetails: {
              password: invalidPasswordMessage
            }
          }
        });
      }
    }

    let details: api.UserPut = {
      name: name.getValue(),
      email: email.getValue()
    };

    // If a new user photo was uploaded, include it
    if (photoID !== undefined) {
      details["photo"] = photoID;
    }

    let newPassword = password.getValue();
    if (newPassword) details.password = newPassword;

    this.saveNotificationSettings(() => {
      // userActions.updateDetails(details);
      this.setState({ saving: true, changed: false, errors: null });
    });
  };

  cancel = () => {
    let { user } = this.state;
    let { name, email, password, confirmPassword } = this.refs;

    this.setState({
      photoData: null,
      changed: false
    });

    email.setState({ value: user?.email });
    name.setState({ value: user?.name });
    password.setState({ value: "" });
    confirmPassword.setState({ value: "" });
  };

  renderActions() {
    if (this.getIsLoading()) {
      return this.renderLoading();
    }

    return (
      <div style={{ position: "absolute", right: "0px", bottom: "0px" }}>
        <Button onClick={this.props.handleDialogClose}>Cancel</Button>
        <Button
          disabled={!this.state.changed}
          loading={this.state.saving}
          {...saveButtonProps}
          onClick={this.updateProfile}
          text="Save"
        />
      </div>
    );
  }

  buildSlackRegistrationURL = (userID: string, orgID: string) => {
    const base = process.env.NEXT_PUBLIC_SLACK_INTEGERATION_URI;

    const slackBase = "https://slack.com/oauth/v2/authorize?scope=";
    const slackScope = "incoming-webhook,chat:write,channels:read,im:write";
    const slackClientID = "1041211408599.1026434037874";

    const constructedQuery =
      slackBase +
      slackScope +
      "&client_id=" +
      slackClientID +
      "&redirect_uri=" +
      base +
      "slack%3FuserID=" +
      userID +
      "%26orgID=" +
      orgID;

    return constructedQuery;
  };

  renderCurrentSlackChannel = () => {
    const { existingSlackChannels } = this.state;

    const { orgID } = this.props;

    const channelForThisOrg = find(existingSlackChannels, (channel) => {
      //@ts-ignore
      return channel.orgID === orgID;
    });

    if (channelForThisOrg === undefined) {
      return "Not Connected To Slack";
    }

    //@ts-ignore
    const authBundle = JSON.parse(channelForThisOrg.auth);

    // Try and pull out the channel name
    try {
      return "Selected Slack Channel: " + authBundle.incoming_webhook.channel;
    } catch (e) {
      return "Not Connected To Slack";
    }
  };

  renderSlackCacheMessage = () => {
    return (
      <ListItem>
        <h4>Slack</h4>
        <b>ATTENTION:</b>
        <p>
          We recommend that you select "Your name (you)" in the Direct Messages
          section of the following slack authorization page. This allows
          Innovation Within to send notifications to you in Slack.
          <img
            style={{
              display: "block",
              width: "80%",
              margin: "auto",
              marginTOp: "20px"
            }}
            src="https://innovation-within-app-prod.s3-us-west-2.amazonaws.com/slack-authorization-example.PNG"
          />
        </p>
        <Button
          className="iw-button"
          onClick={() => {
            //@ts-ignore
            (typeof window !== "undefined" ? window : {}).location =
              this.state.cachedSlackURL;
          }}
        >
          Continue To Slack
        </Button>
      </ListItem>
    );
  };

  renderSlackIntegerator = () => {
    const { loadingSlackChannels, cachedSlackURL } = this.state;

    if (loadingSlackChannels) {
      return (
        <span style={{ display: "block", margin: "auto", marginTop: "30px" }}>
           <LinearProgress />
        </span>
      );
    }

    if (cachedSlackURL !== undefined && cachedSlackURL !== "") {
      return this.renderSlackCacheMessage();
    }

    const slackURI = this.buildSlackRegistrationURL(
      this.state.user.id,
      this.props?.orgID
    );

    const connectSlackButton = (
      <a
        style={{ display: "block", marginTop: "10px", cursor: "pointer" }}
        onClick={() => {
          this.setState({
            cachedSlackURL: slackURI
          });
        }}
      >
        <img
          alt="Add to Slack"
          style={{ height: 40, width: 139 }}
          src="https://platform.slack-edge.com/img/add_to_slack.png"
          srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
        />
      </a>
    );

    return (
      <ListItem>
        <h4>Slack</h4>
        <p>
          In order to recieve your notifications in a slack channel we recommend
          you integerate our Discovery slack app below to a personal or
          instructor only channel. The slack bot will then private message you
          notifications as they occur in the Discovery platform.
        </p>
        <table className="iw-table iw-table-overview" style={{ width: "100%" }}>
          <tr>
            <td>{this.renderCurrentSlackChannel()}</td>
            <td style={{ width: "40px" }}>{connectSlackButton}</td>
          </tr>
        </table>
      </ListItem>
    );
  };

  getIsLoading = () => {
    const { loadingNotificationSettings } = this.state;

    return loadingNotificationSettings === true;
  };

  renderLoading = () => {
    return (
      <Box anchor={false} dynamic>
        <div style={{ display: "block", margin: "auto" }}>
          <LinearProgress />
        </div>
      </Box>
    );
  };

  render() {
    return (
      <div>
        {this.renderBody()}
        {this.renderActions()}
      </div>
    );
  }

  renderBody() {
    const user = this.props.user;

    let { photoData } = this.state,
      { photo } = user,
      imgSrc =
        photo && photo?.dataURL
          ? discoveryAPI.artifactURL(photo?.dataURL)
          : undefined;

    if (this.getIsLoading()) {
      return this.renderLoading();
    }

    if (photoData) {
      imgSrc = URL.createObjectURL(photoData);
    }

    return <Box></Box>;
  }
}
